import { render, staticRenderFns } from "./indexg.vue?vue&type=template&id=4ea89c9e&scoped=true&lang=pug"
import script from "./indexg.vue?vue&type=script&lang=js"
export * from "./indexg.vue?vue&type=script&lang=js"
import style0 from "./indexg.vue?vue&type=style&index=0&id=4ea89c9e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea89c9e",
  null
  
)

export default component.exports